import React from 'react';
import styled from 'styled-components';
import { Loading } from '@sede-enterprise/shell-ds-react-framework';

const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
`;
const Loader = () => {
  return (
    <LoaderContainer data-testid='loader-item'>
      <Loading size='large' />
    </LoaderContainer>
  );
};

export default Loader;
